import {Api} from "./ModelsEventPublic";

export default class EventPublicApiClientFactory{
    static GetApiClient(){
        return new Api({
            baseUrl: process.env.REACT_APP_API_LOCATION,
            baseApiParams: {
                credentials: "include",
                mode: "cors"
            }
        });
    }
}